import {NEW_ITEM_PENDING, CREATE_ITEM_PENDING, UPDATE_REFERRER} from 'actions/pendingItem'

export default (state = null, action) => {
    let types = {};
    types[NEW_ITEM_PENDING] = action.payload;
    types[CREATE_ITEM_PENDING] = null;
    types[UPDATE_REFERRER] = Object.assign({}, state, action.payload);

    return (action.type in types) ? types[action.type] : state;
}
